import { SelectOptions } from '../../../../../shared/form/inputs/Select';

export type DownlossTypeCode = 'GroundBelow' | 'VoidBelow' | 'RoomBelow';

export const downlossTypeCodeSelectOptions: SelectOptions<DownlossTypeCode> = [
  { text: 'Ground Below', value: 'GroundBelow' },
  { text: 'Void Below', value: 'VoidBelow' },
  { text: 'Room Below', value: 'RoomBelow' },
];

export const getDownlossTypeDefaultTemperatures = (
  defaultExternalAirTemperature: number,
): { [key: string]: string } => ({
  GroundBelow: '10',
  VoidBelow: defaultExternalAirTemperature.toString(),
  RoomBelow: '16',
});
